module.exports = __webpack_public_path__ + "img/galeria-esp-marinas-2.582ed872.jpg";